// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type TimeZoneContext from '../contract/TimeZoneContext';

export default function timeZoneContext(data: TimeZoneContext): TimeZoneContext {
    const result: TimeZoneContext = {
        __type: 'TimeZoneContext:#Exchange',
        ...data,
    };

    return result;
}
